import { RegistryFirebaseService } from './../registry/registry-firebase.service';

import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { HeaderType } from '../shared/header-type';
import { UserService } from '../user/user.service';
import { RegistryService } from '../registry/registry.service';

@Component({
  selector: 'app-registry404',
  templateUrl: './registry404.component.html',
  styleUrls: ['./registry404.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class Registry404Component implements OnInit {
  headerType: HeaderType;
  loaded:boolean =false;
  constructor(
    private router: Router,

    private route: ActivatedRoute,
    private _userService: UserService,
    private _registryService: RegistryService,

    private _registryFirebaseService : RegistryFirebaseService,
  ) { }

  ngOnInit() {
    this.route.data.subscribe(data => {
      this.headerType = data["header"] as HeaderType;

    });


    // this._registryFirebaseService.registry$.subscribe(registry => {

    //   if (registry.isLive) {

    //     this.router.navigate(['/']);

    //   }
    //   this.loaded =true;
    // });



  }


}






// WEBPACK FOOTER //
// ./src/app/registry404/registry404.component.ts